import React from "react";

import { useNavigate } from "react-router-dom";
import PersistentDrawerLeft from "./PersistentDrawerLeft";

function Dashboard() {
  let userData = JSON.parse(localStorage.getItem("admin-info"));
  const navigate = useNavigate();

  return userData ? (
    <div>
      <PersistentDrawerLeft />
    </div>
  ) : (
    <div>{navigate("/")}</div>
  );
}

export default Dashboard;
